export default __webpack_public_path__ + "static/media/pg-45.8f036ef4.jpg";